import { render, staticRenderFns } from "./Proliteracy.vue?vue&type=template&id=1011ba21&scoped=true"
import script from "./Proliteracy.vue?vue&type=script&lang=js"
export * from "./Proliteracy.vue?vue&type=script&lang=js"
import style0 from "./Proliteracy.vue?vue&type=style&index=0&id=1011ba21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011ba21",
  null
  
)

export default component.exports